import ReactDOM from 'react-dom';

export default function SlashCommandDropdown({ state, onSelect }) {
  if (!state.visible || state.items.length === 0) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'absolute',
        top: state.top,
        left: state.left,
        background: 'white',
        border: '1px solid #ddd',
        borderRadius: '4px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        maxHeight: '250px',
        overflowY: 'auto',
        zIndex: 10001,
        minWidth: '200px',
        maxWidth: '400px',
      }}
    >
      {state.items.map(([key, value], index) => (
        <div
          key={key}
          style={{
            padding: '8px 12px',
            cursor: 'pointer',
            borderBottom: index < state.items.length - 1 ? '1px solid #eee' : 'none',
            backgroundColor: index === state.selectedIndex ? '#f0f7ff' : 'white',
            color: index === state.selectedIndex ? '#005eab' : 'inherit',
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(index);
          }}
        >
          <span
            style={{
              fontWeight: 'bold',
              fontFamily: 'Poppins, sans-serif',
              fontSize: '12px',
              display: 'block',
            }}
          >
            {key}
          </span>
          <span
            style={{
              fontSize: '12px',
              color: '#666',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
            }}
          >
            {value.substring(0, 50)}...
          </span>
        </div>
      ))}
    </div>,
    document.body
  );
}
